<div [class]="containerClass">
    <mat-form-field [class]="fieldClass">
        <mat-label appRemoveAriaOwns>{{ firstDayOfPeriodLabel | translate }}</mat-label>
        <mat-select
            required
            name="quarterlyPeriods"
            #quarterlyPeriodsModel="ngModel"
            placeholder="{{ firstDayOfPeriodLabel | translate }}"
            [ngModel]="getQuarterlyPeriods()"
            (ngModelChange)="quarterlyPeriodSelection = $event"
        >
            <mat-option *ngFor="let period of quarterlyPeriods" [value]="period.label.en_CA">{{
                period.label[locale]
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div *ngIf="quarterlyPeriodSelection" [class]="containerClass">
    <mat-form-field [class]="fieldClass">
        <mat-label appRemoveAriaOwns>{{ 'time-off-v3.whichDayOfMonth' | translate }}</mat-label>
        <mat-select
            required
            [ngModel]="getDayForQuarterlyPeriods()"
            (ngModelChange)="setQuarterlyPeriods($event)"
            (selectionChange)="previewDataChanged()"
            name="dayOfMonth"
            #dayOfMonth="ngModel"
            placeholder="{{ 'time-off-v3.dayOfMonth' | translate }}"
        >
            <mat-option *ngFor="let day of quarterlyDays" [value]="day">{{
                day > 0 ? (day | ordinalNumber) : ('time-off-v3.lastDay' | translate)
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
